import React, { useState } from "react";
import { Collapse } from 'react-bootstrap';
import FormContact from "../Form/Form";
import FormMobile from "../Form/FormMobile";
import { BsFillPlayFill, BsPauseFill } from "react-icons/bs";
import { useContext } from "react";
import { VideoContext } from "../../videoContext";
import ButtonList from "../ButtonList/ButtonList";

function ClubFitting() {

    const [open, setOpen] = useState(false);

    const [open1, setOpen1] = useState(false);


    const value = true;

    const club = [
        {
            id: 8,
            title: "Club Fitting",
            url: "https://player.vimeo.com/video/844417814?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=0",
        },

    ];


    const { currentPlayingIndex, setCurrentPlayingIndex, handlePlay, playVideo, pauseVideo, playerRefs, index } = useContext(VideoContext);



    return (
        <>

            <section id="club_fitting" className="club_fitting bg_white page-section">
                <div className="container-xl">
                    <div className="d-flex align-items-center justify-content-between sec_tile_bar">
                        <div className="">
                            <h2 className="sec_title title_dark">Club Fitting</h2>
                        </div>
                        <div className="btn-section hide_mobile">
                            <ButtonList subject = "club fitting" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="card hide_mobile">
                                <div className="card-body">
                                    <h4 className="card-title">Interested in a fitting?</h4>
                                    <FormContact subject="club fitting" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="video_card pr_img">

                                {club.map((video, index) => (
                                    <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper" key={video.id}>
                                        <div id="v-video" className="v-video">
                                            <iframe ref={(ref) => (playerRefs.current[video.id] = ref)} src={video.url} frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen="" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} title="JuniorLandingEnrollConfirmation" data-ready="true"></iframe>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="row">
                                <div className="col-lg-6 accordion-item acc_items">
                                    <div className="points_sec">
                                        <h4 className="custom-collapse" id="fitter_p1">
                                            <span className="collapsed">
                                                Custom Built
                                                {/* <img className="hide_desktop" src={require('../../assets/images/angle_down.png')} /> */}
                                            </span>
                                        </h4>

                                        <p id="fitter_pc1" className="accordion-collapse" aria-labelledby="fitter_p1">
                                            All your fitted equipment is built to the absolute specification achieved in your fitting session to ensure that the clubs you play perform.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6 accordion-item acc_items">
                                    <div className="points_sec">
                                        <h4 className="custom-collapse" id="fitter_p2">
                                            <span className="collapsed">
                                                Custom Clubs
                                                {/* <img className="hide_desktop" src={require('../../assets/images/angle_down.png')} /> */}
                                            </span>
                                        </h4>

                                        <p id="fitter_pc2" className="accordion-collapse" aria-labelledby="fitter_p2">
                                            You have complete creative control when choosing your favorite ferrule colors, shaft color and decals, and grip type, feel and color.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="card show_mobile">
                                <div className="card-body">
                                    <h4 className="card-title">Interested in a fitting?</h4>
                                    <FormMobile subject="club fitting" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}

export default ClubFitting;